import {CheckoutOrder} from '@platform/checkout/domain/models/checkout-order.model';

export interface SupplementDTO {
  ticketEventId: string;
  supplementId: string;
  quantity: number;
}

export enum PaymentMethod {
  CASH = 'cash',
  CARD = 'card',
  WALLET = 'wallet',
  COMPLEMENT = 'complement',
  CONSUMPTION = 'consumption',
}

export enum PaymentGateway {
  API = 'api',
  TERMINAL = 'terminal',
  TAP_TO_PAY = 'taptopay',
  WALLET = 'wallet',
  CUSTOMER = 'customer',
}

export enum PaymentProvider {
  ADYEN = 'adyen',
  DEFAULT = 'default',
}

export enum PaymentType {
  FULL = 'full',
  SPLIT = 'split',
}

export enum PaymentStatus {
  IDLE = 'IDLE',
  PROCESSING = 'PROCESSING',
  CHECKOUT = 'CHECKOUT',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  ERROR = 'ERROR',
}

export enum PaymentPollingStatus {
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
  WAITING_OPEN_TAP_TO_PAY = 'waiting_open_tap_to_pay',
}

export interface PaymentVerificationResult {
  status: PaymentPollingStatus;
  error?: string;
}

export interface PaymentCreationParams {
  userSelectedMethod: PaymentMethod;
  amount?: number;
  walletId?: string;
  supplement?: SupplementDTO;
}

export interface PaymentDTO {
  amount: number;
  order: CheckoutOrder;
  method: PaymentMethod;
  gateway: PaymentGateway;
  provider: PaymentProvider;
  status: PaymentStatus;
  paymentType: PaymentType;
  transactionId?: string;
  error?: string;
  sourceId?: string;
  walletId?: string;
  supplement?: SupplementDTO;
}

export interface PaymentProps extends Partial<PaymentDTO> {
  amount: number;
  order: CheckoutOrder;
  method: PaymentMethod;
  gateway: PaymentGateway;
}
